import { NotFoundPage, PaginationProvider, Spinner } from "dash-ui";
import { useNavigate, useParams } from "react-router-dom";
import { useGetPropertyByIdQuery } from "gql/generated.graphql";
import { RoutesPath } from "flow-components/routes/routes";
import PropertyUserPreviewPageContent from "./components/PropertyUserPreviewPageContent";

interface PropertyUserPreviewPageProps {
  isSeeker?: boolean;
}

function PropertyUserPreviewPage({
  isSeeker = false,
}: PropertyUserPreviewPageProps) {
  const { id } = useParams();
  const { data, loading } = useGetPropertyByIdQuery({
    variables: { propertyId: id },
  });
  const property = data?.getPropertyById;
  const navigate = useNavigate();

  if (!property && !loading) {
    return <NotFoundPage onRedirect={() => navigate(RoutesPath.Properties)} />;
  }

  if (loading) {
    return <Spinner size={42} fullContent />;
  }

  return (
    <PaginationProvider perPage={5}>
      <PropertyUserPreviewPageContent
        property={property!}
        isSeeker={isSeeker}
      />
    </PaginationProvider>
  );
}

export default PropertyUserPreviewPage;